import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from './icon.png';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/projects', label: 'Projects' },
    { path: '/education', label: 'Education' },
    { path: '/experience', label: 'Experience' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className="navbar-container">
      <div className="navbar-inner">
        {/* Interactive Brand Logo CTA */}
        <Link to="/" className="navbar-brand-cta" title="Return Home" aria-label="Return to homepage">
          <div className="logo-halo-ring"></div>
          <img src={logo} alt="Ayaan Logo" className="logo-img" />
          <span className="logo-brand-text">
            <span className="logo-first-name">Ayaan Nadamal</span>
          </span>
        </Link>

        {/* Center Aurora Pill Menu (Desktop) */}
        <nav className="navbar-pill-nav">
          <div className="nav-links-wrap">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-item-link ${isActive ? 'active' : ''}`}
                >
                  {link.label}
                  {isActive && <span className="active-glow-indicator" />}
                </Link>
              );
            })}
          </div>
        </nav>

        {/* Action Button on the Right */}
        <div className="navbar-action-area">
          <Link to="/game" className="launch-action-btn">
            <span className="launch-btn-dot"></span>
            <span>Launch Game</span>
          </Link>

          {/* Mobile Hamburger Toggle */}
          <button
            className={`navbar-toggler ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation"
          >
            <span className="toggler-bar"></span>
            <span className="toggler-bar"></span>
            <span className="toggler-bar"></span>
          </button>
        </div>
      </div>

      {/* Mobile Drawer Overlay */}
      <div
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      {/* Mobile Drawer Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <span className="mobile-menu-title">Navigation</span>
          <button
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            ✕
          </button>
        </div>

        <div className="mobile-links-list">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/game"
            className="mobile-launch-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Launch Game 🚀
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
